<div class="modal-header">
    {{ title }}
</div>
<div class="modal-body">
    <div class="field-subtitle">
        Import aborted. {{ failureCount }} row(s) failed validation. No records were imported.
    </div>
    <div class="failure-table-holder">
        <table class="failure-table">
            <thead>
                <tr>
                    <th>Row</th>
                    <th>Invoice No</th>
                    <th>Principal</th>
                    <th>Column</th>
                    <th>Reason</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let failure of failures">
                    <td>{{ failure.rowNumber }}</td>
                    <td>{{ failure.invoiceNo }}</td>
                    <td>{{ failure.principalName }}</td>
                    <td>{{ failure.column }}</td>
                    <td>{{ failure.reason }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="buttons">
        <button type="button" class="btn btn-primary ok" aria-label="Close" (click)="close()">Close</button>
    </div>
</div>
